import React from 'react'
import { useQuery } from 'react-query'

import { useUserReadingAction } from '@hooks/userReading/useUserReadingAction'
import {
  NavigateOtherStoryAcceptProps,
  NavigateOtherStoryProps,
} from './interface'

const withNavigateOtherStory = (
  Component: React.FC<NavigateOtherStoryProps>
) => {
  function WithNavigateOtherStory({ bookId }: NavigateOtherStoryAcceptProps) {
    const userReadingClient = useUserReadingAction()

    const { data: previousAndNextBookId } = useQuery(
      ['story', bookId, 'previousAndNextBookId'],
      () => userReadingClient.getPreviousAndNextBookId(bookId),
      { enabled: !!bookId }
    )

    const newProps = { previousAndNextBookId }
    return <Component {...newProps} />
  }

  return WithNavigateOtherStory
}

export default withNavigateOtherStory
